/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import React, { useEffect, useState } from "react";
import moment from "moment/moment";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { Button } from "@mui/material";
import MDTypography from "components/MDTypography";
import MyDocument from "./Component/PDF";
import { PDFDownloadLink, StyleSheet } from '@react-pdf/renderer';
import { getCookie } from "cookie/cookie";
import axios from "axios";
import { apiBaseUrl } from "config";
import { apiVersionPrefix } from "config";
import { useDispatch, useSelector } from "react-redux";
import { getSingeClient } from "Redux/actions/mobileFinnance";

const styles = StyleSheet.create({
  download: {
    color: "white",
    cursor: "pointer",
  },
});
export default function CustomizedTables({ transactions, handleAction,service }) {
  const dispatch = useDispatch();
  const [isDownloading, setIsDownloading] = useState(false);
  const [clientTransactions, setClientTransactions] = useState([]);

  let client = service==='bKash'?localStorage.getItem('clientName'):localStorage.getItem('nagadClientName');
  let clientNumber = service==='bKash'?localStorage.getItem('client'):localStorage.getItem('nagadClient');
  useEffect(() => {
    dispatch(getSingeClient(clientNumber, service))
  }, [dispatch, clientNumber, service])


  let singleClient = useSelector((state) => state?.client);
  singleClient = singleClient?.client?.client

  const handleDownload = async() => {
    
    const config = {
      headers: {
          "Content-Type": "application/json",
          'Authorization': `Bearer ${getCookie("token")} `,
      },
  };
  
  const { data } =  await axios.get(
      `${apiBaseUrl}${apiVersionPrefix}/mobile-finnance/get-all-transactions?page=${1}&limit=${5000}&client=${clientNumber?clientNumber:'all'}&service=${service}`,
      config
  );
  setClientTransactions(data);
  setIsDownloading(true);
  };
  // console.log(clientTransactions)
 
  
  return (
    <div className="table">
      <Button sx={{ mb: "10px", mr: "5%", float: "right" }} onClick={handleDownload} variant="contained" color="secondary" >

        {(!isDownloading) && <MDTypography color="white" fontSize="small">CREATE PDF</MDTypography>}
        {isDownloading && (
          <PDFDownloadLink style={styles.download} document={<MyDocument transactions={clientTransactions} service={service} client={client} singleClient={singleClient} />} fileName={`${client}-${service}.pdf`}>
            {({ blob, url, loading, error }) =>
              loading ? 'Loading document...' : 'Download'
            }
          </PDFDownloadLink>
        )}
      </Button>
      <table>
        <tr>
          <th>#</th>
          <th>Name/Number</th>
          <th>Amount</th>
          <th>Pin</th>
          <th>Type</th>
          <th>Date</th>
          <th>Action</th>
        </tr>
        {transactions?.map((transaction, index) => (
          <tr key={index}>
            <td>{transaction?.index}</td>
            <td>{transaction.number}</td>
            <td>{transaction.amount}</td>
            <td>{transaction.pin}</td>
            <td>{transaction.type}</td>
            <td>{moment(transaction?.date).format('DD MMM YYYY')}</td>
            <td><button onClick={() => handleAction(transaction)} className="edit-button"><ModeEditOutlinedIcon /></button></td>
          </tr>
        ))}

      </table>
    </div>
  )
}